import { useRouteCheck } from 'app/components/RouteListCards/RoutesWithoutTaskListCard/hooks/useRouteCheck';
import { useCreateOrUpdateTaskRoutes } from 'app/containers/Task/pages/CreateOrUpdateTask/hooks/useCreateOrUpdateTaskRoutes';
import { useParams } from 'react-router-dom';
import { scrollToElementById } from 'utils/helpers';
import { useTaskRouteFields } from './useTaskRouteFields';

export const useTaskRoutesMapItems = () => {
  const params = useParams<{
    taskId: string;
  }>();

  const taskId = Number.isNaN(Number(params.taskId))
    ? undefined
    : Number(params.taskId);

  const { taskRoutes } = useCreateOrUpdateTaskRoutes({ taskId });

  const { routeFields } = useTaskRouteFields({
    taskRoutes,
  });

  const { checkedRouteIds, onRoutesCheck, checkedRoutes } = useRouteCheck({
    routes: taskRoutes,
  });

  const onFieldClick = ({
    fieldSeasonId,
    routeId,
  }: {
    fieldSeasonId?: number;
    routeId?: number;
  }) => {
    if (!fieldSeasonId) {
      return;
    }
    scrollToElementById(`routeItem${routeId}`);
    if (routeId) {
      onRoutesCheck([routeId]);
    }
  };

  return {
    checkedRoutes,
    onFieldClick,
    checkedRouteIds,
    routeFields,
  };
};
